import React from 'react';
import AdpPrivateCloudSnowflakeUpload from "./AdpPrivateCloudSnowflakeUpload";

// the geography tables are not included, the DAG reads them from the Geo/Market publish for the period and schema
export const MEASURES_TABLES_TO_INCLUDE = [
    "prop_fact_pos",
    "prop_geography_demographics",
    "prop_fact_acv",
    "prop_projection_weights",
    "prop_dim_location",
    "prop_geography_store_mapping",
    "prop_pl_item_to_geography_mapping"
];

const AdpMeasuresPublish = () =>
    <AdpPrivateCloudSnowflakeUpload pageName={"ADP Measures Publishing"}
                                    extraDagConfig={{tables_to_include: MEASURES_TABLES_TO_INCLUDE}}/>;

export default AdpMeasuresPublish;
